<div class="matero-error-wrap">
  <div class="matero-error-code">{{code}}</div>
  <div class="matero-error-title" *ngIf="title">{{title}}</div>
  <div class="matero-error-message" *ngIf="message">{{message}}</div>
  <div><a mat-raised-button color="primary" routerLink="/" *ngIf="showHomeButton">Back to Home</a></div>
</div>